<template>
  <div class="divider" />
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@keyframes move {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(400%);
  }
}

.divider {
  background-color: rgba(13, 91, 219, 0.2);
  border-radius: 2px;
  height: 2px;
  position: relative;
  width: 120px;

  &::before {
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-name: move;
    animation-timing-function: linear;
    background: #0d5bdb;
    border-radius: 4px;
    content: '';
    height: 4px;
    left: 0;
    position: absolute;
    top: -1px;
    width: 24px;
  }
}
</style>
